import * as React from 'react'
import { IconButton, Icon } from '@material-ui/core'
import * as ResourceIcon from 'components/Icon/Resource'
import styled from 'styled-components'

type Props = {
  onClose?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  resource: { type: string; name: string }
}

const Component: React.FC<Props> = ({ onClose, onClick, resource }) => {
  return (
    <List>
      <ResourceIcon.Type
        width="2em"
        height="2em"
        type={resource.type}
        style={{ margin: '0 10px' }}
      />
      <Name onClick={onClick}>{resource.name}</Name>
      <IconButton onClick={onClose}>
        <Icon>close</Icon>
      </IconButton>
    </List>
  )
}

export default Component

const List = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: '10px',
  boxShadow: '0 0 8px rgba(0, 0, 0, 0.1)',
  padding: '10px 10px 10px 10px',
})

const Name = styled.div({
  fontWeight: 700,
  flex: 1,
})
